import { makeStyles } from "@material-ui/core/styles"

export const useEmptyStyles = makeStyles(() => ({
    root: {
        position: "absolute",
        width: "100%",
        height: "100%",
        transition: "all ease .3",
    },
    move: {
        transition: "all ease .3",
    },
    moveBoard: {
        color: "white",
        backgroundColor: "#999",
        position: "absolute",
        width: "90%",
        borderRadius: 6,
        right: 4,
        top: 4,
        zIndex: 1,
        padding: "0 20px 0 10px",
        height: 40,
        wordBreak: "break-word",
    },
}))
